import SlideUp from '@/common/utils/slideUp';
import { Maybe } from '@/typings/types';

type TitleProps = {
  title: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  subtitle?: Maybe<string> | undefined;
};

type ProductsTitleProps = {
  title: string;
};

export const SectionTitle = ({ title, as, subtitle }: TitleProps) => {
  const Tag = as ?? 'h2';

  return (
    <SlideUp yOffset={50}>
      <Tag className={'text-5xl tracking-wider uppercase font-stigsaMedium mb-6'}>
        {title}
        {subtitle && (
          <span className={'block text-3xl font-normal tracking-wider font-stigsaMedium'}>
            {subtitle}
          </span>
        )}
      </Tag>
    </SlideUp>
  );
};

export const ProductsTitle = ({ title }: ProductsTitleProps) => {
  return (
    <SlideUp yOffset={25}>
      <dt className={'text-3xl font-bold tracking-wider uppercase font-stigsaMedium mb-3'}>
        {title}
      </dt>
    </SlideUp>
  );
};
